import * as React from 'react'
import { addCart, openWindow } from '../../Util'

import './index.css'

class Modal extends React.Component {
  state = {
    activeCls: ''
  }
  
  handleItemClick = (item) => {
    let { loadPanorama } = this.props
    let { id } = item
    console.log(item) // eslint-disable-line
    loadPanorama(id)
  }

  activeModal = () => {
    setTimeout(() => {
      this.setState({
        activeCls: 'active'
      })
    }, 80)
  }

  addCart = ({ itemId }) => {
    console.log(itemId)
    addCart(itemId)
  }

  goDetail = ({ itemId }) => {
    openWindow(`http://h5.m.taobao.com/awp/core/detail.htm?id=${itemId}`)
  }
  
  componentDidMount() {
    this.activeModal()
  }
  
  render() {
    let { item, hideModal } = this.props
    let { activeCls } = this.state
    return (
      <div className={`modal container ${activeCls}`}>
        <div className="wrapper">
          {!item.pictUrl ? <div className="pic">暂无图片</div> : <img className="pic" src={item.pictUrl} alt="pic" />}
          <div className="desc">
            <span className="title">{item.title}</span>
          </div>
          <div className="price-wrapper">
            <span className="label">价格 </span>
            <span className="price">￥{item.price}</span>
          </div>
          <div className="btn-wrapper">
            <div className="cart" onClick={() => this.addCart(item)}>加入购物车</div>
            <div className="detail" onClick={() => this.goDetail(item)}>查看详情</div>
          </div>
        </div>
        <div className="close" onClick={hideModal}></div> 
      </div>
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/Components/Modal/index.js